module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/scientific-american-2x.413fd29bbfb1d2ee7535a62d23a46d33.png";